import { Link, useNavigate } from 'react-router';

import { getHomePath } from '@/entities/session';
import { images } from '@/shared/assets/images/images';
import { useAppSelector } from '@/shared/model/storeHooks';

import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  const auth = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const fallbackPath = getHomePath(auth);

  return (
    <div className={styles.page} onClick={() => navigate(fallbackPath)}>
      <img className={styles.logo} src={images.logo} alt="" />
      <div className={styles.content}>
        <div className={styles.code}>404</div>
        <p>Unfortunately, this page doesnâ€™t exist.</p>
        <p>
          Try <Link to={fallbackPath}>start from the main page</Link>
        </p>
      </div>
    </div>
  );
}
